import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/HomePage.vue'),
  },
  {
    path: '/answerQuestion',
    name: 'AnswerQuestion',
    component: () => import('@/views/AnswerQuestion.vue'),
  },
  {
    path: '/knowledgeStudy',
    name: 'KnowledgeStudy',
    component: () => import('@/views/KnowledgeStudy.vue'),
  },
  {
    path: '/answerRules',
    name: 'AnswerRules',
    component: () => import('@/views/AnswerRules.vue'),
  },
];

export default routes;
